export default __webpack_public_path__ + "static/media/msit.991641a9.png";